export enum Variant {
  DEFAULT = 'default',
  PADDED = 'padded',
}

export enum Size {
  FIXED = 'fixed',
  FULL = 'full',
  FREE = 'free',
}
